/**
 * @generated SignedSource<<944849d9b468cb7762f517b8e800e3ee>>
 * @relayHash 0a22f0f904233e12aeb8f1085117e284
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22ceaa941ce71fc7bc67f82e86c6d380cbbf7dfb46c821e1406d50d893d492a2

import type { ConcreteRequest } from 'relay-runtime';
export type JiraCFORecommendationGroup = "LIMITS_AND_CLEANUP" | "NONE" | "USER_SETUP" | "%future added value";
export type JiraCFORecommendationStatus = "CRITICAL" | "INFO" | "WARNING" | "%future added value";
export type RecommendationPanelContextQuery$variables = {
  cloudId: string;
};
export type RecommendationPanelContextQuery$data = {
  readonly jira: {
    readonly cfoRecommendationGroups: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly description: string;
          readonly groupCategory: JiraCFORecommendationGroup;
          readonly name: string;
          readonly sidePanelDescription: string;
          readonly sidePanelTitle: string;
          readonly status: JiraCFORecommendationStatus;
        };
      } | null>;
    };
    readonly cfoRecommendations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly actions: ReadonlyArray<{
            readonly link: string;
            readonly name: string;
          } | null>;
          readonly created: AGG$DateTime;
          readonly description: string;
          readonly group: JiraCFORecommendationGroup;
          readonly name: string;
          readonly recommendationCategory: string;
          readonly resources: ReadonlyArray<{
            readonly link: string;
            readonly name: string;
          } | null>;
          readonly status: JiraCFORecommendationStatus;
        };
      } | null>;
    };
  };
};
export type RecommendationPanelContextQuery = {
  response: RecommendationPanelContextQuery$data;
  variables: RecommendationPanelContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "recommendationCategory"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "RequiredField",
  "field": (v3/*: any*/),
  "action": "THROW"
},
v5 = {
  "kind": "ScalarField",
  "name": "description"
},
v6 = {
  "kind": "RequiredField",
  "field": (v5/*: any*/),
  "action": "THROW"
},
v7 = {
  "kind": "ScalarField",
  "name": "group"
},
v8 = {
  "kind": "ScalarField",
  "name": "link"
},
v9 = [
  (v4/*: any*/),
  {
    "kind": "RequiredField",
    "field": (v8/*: any*/),
    "action": "THROW"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "created"
},
v11 = {
  "kind": "ScalarField",
  "name": "status"
},
v12 = {
  "kind": "RequiredField",
  "field": (v11/*: any*/),
  "action": "THROW"
},
v13 = {
  "kind": "ScalarField",
  "name": "groupCategory"
},
v14 = {
  "kind": "ScalarField",
  "name": "sidePanelTitle"
},
v15 = {
  "kind": "ScalarField",
  "name": "sidePanelDescription"
},
v16 = [
  (v3/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RecommendationPanelContextQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraCFORecommendationConnection",
                "kind": "LinkedField",
                "name": "cfoRecommendations",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraCFORecommendationEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraCFORecommendation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v2/*: any*/),
                                "action": "THROW"
                              },
                              (v4/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": (v7/*: any*/),
                                "action": "THROW"
                              },
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraCFORecommendationLink",
                                  "kind": "LinkedField",
                                  "name": "actions",
                                  "plural": true,
                                  "selections": (v9/*: any*/)
                                },
                                "action": "THROW"
                              },
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraCFORecommendationLink",
                                  "kind": "LinkedField",
                                  "name": "resources",
                                  "plural": true,
                                  "selections": (v9/*: any*/)
                                },
                                "action": "THROW"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v10/*: any*/),
                                "action": "THROW"
                              },
                              (v12/*: any*/)
                            ]
                          },
                          "action": "THROW"
                        }
                      ]
                    },
                    "action": "THROW"
                  }
                ]
              },
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraCFORecommendationGroupDetailConnection",
                "kind": "LinkedField",
                "name": "cfoRecommendationGroups",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraCFORecommendationGroupDetailEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraCFORecommendationGroupDetail",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": (v13/*: any*/),
                                "action": "THROW"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v14/*: any*/),
                                "action": "THROW"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v15/*: any*/),
                                "action": "THROW"
                              },
                              (v12/*: any*/)
                            ]
                          },
                          "action": "THROW"
                        }
                      ]
                    },
                    "action": "THROW"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecommendationPanelContextQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCFORecommendationConnection",
            "kind": "LinkedField",
            "name": "cfoRecommendations",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFORecommendationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraCFORecommendation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "JiraCFORecommendationLink",
                        "kind": "LinkedField",
                        "name": "actions",
                        "plural": true,
                        "selections": (v16/*: any*/)
                      },
                      {
                        "concreteType": "JiraCFORecommendationLink",
                        "kind": "LinkedField",
                        "name": "resources",
                        "plural": true,
                        "selections": (v16/*: any*/)
                      },
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraCFORecommendationGroupDetailConnection",
            "kind": "LinkedField",
            "name": "cfoRecommendationGroups",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraCFORecommendationGroupDetailEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraCFORecommendationGroupDetail",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "22ceaa941ce71fc7bc67f82e86c6d380cbbf7dfb46c821e1406d50d893d492a2",
    "metadata": {},
    "name": "RecommendationPanelContextQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4f911dcbaa55da2d7e52de6cccbd7ec6";

export default node;
